import React, { useCallback, useState, useEffect } from 'react';
import { useMergeLink } from '@mergeapi/react-merge-link';
import { useNavigate } from 'react-router-dom';

import { saveAccountToken } from 'api/hris-integration';
import ProcessingModal from 'components/processing-modal';
import { Report } from 'graphql-api';
import { navigateAndStoreStep } from 'utils/navigation';
import { IMPORTING_HRIS_DATA_STEP } from 'constants/report-steps';

function MergeLink({
  report,
  linkToken,
  integration,
  setProcessing
}: {
  report: Report;
  linkToken: string;
  integration: string;
  setProcessing: Function;
}): JSX.Element {
  const navigate = useNavigate();
  const [publicToken, setPublicToken] = useState<string | undefined>(undefined);
  const [showProcessingModal, setShowProcessingModal] = useState<boolean>(false);

  const onMergeLinkSuccess = useCallback(async (publicToken: string) => {
    setPublicToken(publicToken);
  }, []);

  const onExit = async (): Promise<void> => {
    setProcessing(false);

    if (publicToken !== undefined) {
      setShowProcessingModal(true);
      const result = await saveAccountToken(report?.id, publicToken, integration);
      if (result) {
        await navigateAndStoreStep(report, IMPORTING_HRIS_DATA_STEP, navigate);
      } else {
        setShowProcessingModal(false);
        alert(
          'Sorry there was an issue connecting your HRIS/Payroll provider. Please try connecting it again.'
        );
      }
    }
    setPublicToken(undefined);
  };

  const { open, isReady }: { open: () => void; isReady: boolean } = useMergeLink({
    linkToken,
    onSuccess: (publicToken) => {
      void onMergeLinkSuccess(publicToken);
    },
    onExit: () => {
      void onExit();
    }
  });

  useEffect(() => {
    if (isReady) open();
  }, [isReady]);

  return <>{showProcessingModal && <ProcessingModal header="Setting up HRIS Connection..." />}</>;
}

export default MergeLink;
